import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class LinkedinFeedSlider {
	constructor() {
		this.instances = new Map();
	}

	init() {
		for (const slider of document.querySelectorAll('.buhck-linkedin__slider')) {
			this.initSlider(slider);
		}
	}

	initSlider(slider) {
		if (this.instances.has(slider)) {
			return;
		}

		const controls = slider.querySelector('.buhck-linkedin__controls');
		const previousButton = slider.querySelector(
			'.buhck-linkedin__navigation--previous',
		);
		const nextButton = slider.querySelector(
			'.buhck-linkedin__navigation--next',
		);
		const pagination = slider.querySelector('.buhck-linkedin__pagination');

		if (!controls || !previousButton || !nextButton || !pagination) {
			return;
		}

		const swiper = new Swiper(slider, {
			breakpointsBase: 'container',
			grabCursor: true,
			observer: true,
			observeParents: true,
			slidesPerGroup: 1,
			slidesPerView: 1,
			spaceBetween: 16,
			watchOverflow: true,
			breakpoints: {
				480: {
					slidesPerView: 2,
				},
				1050: {
					slidesPerView: 3,
					spaceBetween: 24,
				},
			},
			navigation: {
				prevEl: previousButton,
				nextEl: nextButton,
			},
			pagination: {
				clickable: true,
				el: pagination,
			},
		});

		const updateControls = () => {
			controls.hidden = swiper.isLocked;
		};

		swiper.on('breakpoint', updateControls);
		swiper.on('lock', updateControls);
		swiper.on('resize', updateControls);
		swiper.on('unlock', updateControls);
		updateControls();

		this.instances.set(slider, swiper);
	}
}
